export const environmentBase = {
  apiKey: {
    med: 'AIzaSyD5Q1-FGHUIJKMNJHY6*IKHUJYGTFRD',
    messageTrace: 'UQsjX3bdHYqEPO2ZeDvdpjPUNZPzQiNP',
  },
};
